"use strict";
'use client';
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SVG = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 32", preserveAspectRatio: "xMidYMid meet", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { d: "M22.849 10.896l-.026-.054a12.04 12.04 0 00-4.503-5.03 12.284 12.284 0 00-.888-.503l-.042-.02A11.937 11.937 0 0012 4C5.373 4 0 9.373 0 16c0 1.585.315 3.094.873 4.479a12.028 12.028 0 006.25 6.478c.331.148.671.278 1.017.396h.001C9.353 27.766 10.648 28 12 28c6.627 0 12-5.373 12-12 0-1.828-.421-3.553-1.151-5.104zm-1.433 1.768L18.88 15.2l-5.657-5.657 2.727-2.727a10.048 10.048 0 015.466 5.848zm-11.615.301l2.714-2.714 5.657 5.657-2.714 2.714-5.657-5.657zm4.949 6.364l-3.398 3.398-5.657-5.657 3.398-3.398 5.657 5.657zM2 16C2 10.486 6.486 6 12 6c1.014 0 1.992.154 2.915.436L2.436 18.916A9.97 9.97 0 012 16zm.816 3.95l2.172-2.172 5.657 5.657-1.981 1.981a10.048 10.048 0 01-5.848-5.466zM12 26a9.933 9.933 0 01-2.243-.263l11.98-11.981c.167.723.263 1.472.263 2.244 0 5.514-4.486 10-10 10z" }),
        React.createElement("circle", { transform: "rotate(-45.001 17.727 10.696)", cx: 17.727, cy: 10.695, r: 1 }),
        React.createElement("circle", { transform: "rotate(-45.001 10.199 18.222)", cx: 10.2, cy: 18.222, r: 1 })));
};
var SvgNeckCircle45C = (0, styled_components_1.default)(SVG)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"], ["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"])), function (_a) {
    var _b = _a.display, display = _b === void 0 ? 'inline-block' : _b;
    return display;
}, function (_a) {
    var _b = _a.fontSize, fontSize = _b === void 0 ? '32px' : _b;
    return fontSize;
});
exports.default = SvgNeckCircle45C;
var templateObject_1;
